export default "### The property market is fine already, shouldn't we try it out somewhere else?\n";